import {
  AppBar,
  Box,
  Button,
  Grid,
  TablePagination,
  TextField,
  Toolbar,
  Typography,
} from '@material-ui/core';
import React, { useEffect, useReducer } from 'react';

import { makeStyles, useTheme } from '@material-ui/styles';
import { Link, useHistory } from 'react-router-dom';
import routes from '../../../../../Utils/routes.json';
import EditOutlined from '@material-ui/icons/EditOutlined';
import { useState } from 'react';
import KenCard from '../../../../../global_components/KenCard';
import KenPopover from '../../../../../Components/KenPopOver';
import KenDialogBox from '../../../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../../../global_components/KenSelect';
import { RiCheckFill, RiNotification3Line } from 'react-icons/ri';
import Kentable from '../../../../../global_components/KenTable/kentable';
import { CheckBox } from '@material-ui/icons';
import KenDateTimePicker from '../../../../../global_components/KenDateTimePicker';
import KenSelect from '../../../../../global_components/KenSelect';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Input from '@material-ui/core/Input';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import Checkbox from '@material-ui/core/Checkbox';
// Icons
import EditIcon from '@material-ui/icons/EditOutlined';
import DoneIcon from '@material-ui/icons/DoneAllTwoTone';
import RevertIcon from '@material-ui/icons/NotInterestedOutlined';
import KenAutoComplete from '../../../../../global_components/KenAutoComplete/index';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import moment from 'moment';
import ChatLayout from '../../../components/ChatLayout';
import ChatInput from '../../../components/ChatInput';
import LastPageIcon from '@material-ui/icons/LastPage';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import PropTypes from 'prop-types';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KenGridEditable from '../../../../../global_components/kenEditDataGrid/KenGridEcditableForStudentStatus';
import '../../../../../style/index.css';
import {
  getEvaluationDetailsData,
  getGradingDetails,
  getRevalData,
  GradingGet,
  postEvaluationDetailsData,
  postRetestData,
} from '../../../../../Utils/apiServices';
import KenButton from '../../../../../global_components/KenButton';
// import '../../../../style/index.css';
import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  Message,
} from '@material-ui/icons';
import KenLoader from '../../../../../Components/KenLoader';
const arrayBreadCrumb = [
  // { head: 'ADMIN PORTAL', url: routes.adminManagement },
  {
    head: 'EXAM',
    url: routes.exam,
  },
  {
    head: 'EVALUATION',
  },
];

export const facultyDropDown = [
  { title: 'Jane Coper', year: 1994 },
  { title: 'Wade warren', year: 1972 },
  { title: 'Jane Coper', year: 1974 },
  { title: 'Wade warren', year: 2008 },
  { title: 'Wade warren', year: 1957 },
];

const onToggleEditMode = (id) => {
  console.log('1234', id);
};
const ActionCellEdit = (row, isUpdating) => {
  const { id } = row.row.values;
  return <EditOutlined className="m-0" onClick={() => onToggleEditMode(id)} />;
};

const CellWithButton = (row) => {
  const classes = useStyles();
  const { seating_plan, id } = row.row.values;

  // console.log({ eligibility_status });

  let classOfBtn;
  if (seating_plan === 'Generate') {
    classOfBtn = classes.Green;
  } else if (seating_plan === 'View / Edit') {
    classOfBtn = classes.Blue;
  } else {
    classOfBtn = classes.medium;
  }
  if (seating_plan === 'Generate') {
    return (
      <>
        <Box>
          <div style={{ display: 'flex' }}>
            <Button
              variant="primary"
              component={Link}
              className={classOfBtn}
              to={`${routes.seatingPlan}/arrangement/${id}`}
            >
              Generate
            </Button>
            <Button
              variant="primary"
              component={Link}
              className={classes.publishGenerate}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              SEND
            </Button>
          </div>
        </Box>
      </>
    );
  } else {
    return (
      <>
        <Box>
          <div style={{ display: 'flex' }}>
            <Button
              variant="primary"
              component={Link}
              className={classes.Blue}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              View / Edit
            </Button>
            <Button
              variant="primary"
              component={Link}
              className={classes.publishView}
              // to={`${routes.currentProgrammes}/${id}/details`}
            >
              SEND
            </Button>
          </div>
        </Box>
      </>
    );
  }
};

const UserCell = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%', marginRight: '10px' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const useStyles = makeStyles((theme) => ({
  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
    height: '50px',
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    textTransform: 'uppercase',
  },
  titleCount: {
    color: '#F14B2D',
    fontSize: 12,
  },
  titleCountSpan: {
    color: '#F14B2D',
    fontSize: 12,
    fontWeight: 'bold',
  },
  subHeaderTitle: {
    width: '100%',
  },
  addButton: {
    color: 'white',
    fontWeight: 'bold',
    height: '28px',
    width: '78px',
    textDecoration: 'none',
    textTransform: 'none',
    '&:hover': {
      color: 'white',
      borderBottom: '1px solid white',
    },
  },
  mainActions: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '2rem 0 1rem',
  },
  error: {
    background: 'orange',
    borderRadius: '25px',
    fontSize: '10px',
    margin: '5px  5px',
    color: 'white',
    '&:hover': {
      color: 'white',
      background: 'orange',
    },
    // color: '#FFFFFF',
    // background: '#EB5757',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  normal: {
    color: 'white',

    background: 'green',

    borderRadius: '20px',
    fontSize: '10px',
    height: '25px',
    margin: '5px 5px',
    '&:hover': {
      background: 'green',

      color: 'white',
    },
    // color: '#FFFFFF',
    // background: '#27AE60',
    // borderRadius: 15,
    // fontSize: '10px',
    // fontWeight: 'bold',
    // margin: '0 5px',
    // width: '102px',
  },
  publishGenerate: {
    color: '#FFFFFF',
    background: '#979797',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  publishView: {
    color: '#FFFFFF',
    background: '#55b0cd',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Blue: {
    color: '#FFFF',
    background: '#03248F',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  Green: {
    color: '#FFFF',
    background: '#27AE60',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
    width: '102px',
  },
  medium: {
    color: '#FFFFFF',
    background: '#F2994A',
    width: '102px',
    borderRadius: 15,
    fontSize: '10px',
    fontWeight: 'bold',
    margin: '0 5px',
  },
  errorText: {
    color: '#F14B2D',
  },
  greenText: {
    color: '#27AE60',
  },
  gridKenClass: {
    '&  table tbody tr td ': {
      padding: '5px',
    },
    '&  table thead tr th ': {
      fontWeight: 'bold',
      color: '#061938',
    },
  },
}));

const selectOptionsCourse = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'BBAECO103-Macroeconomics',
    value: 'BBAECO103-Macroeconomics',
  },
  {
    label: 'BBALIB106-World Cultures',
    value: 'BBALIB106-World Cultures',
  },
];

const selectOptionsFaculty = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'ken42 faculty 1',
    value: 'ken42 faculty 1',
  },
  {
    label: 'ken42 faculty 2',
    value: 'ken42 faculty 2',
  },
  {
    label: 'ken42 faculty 3',
    value: 'ken42 faculty 3',
  },
  {
    label: 'ken42 faculty 4',
    value: 'ken42 faculty 4',
  },
  {
    label: 'ken42 faculty 5',
    value: 'ken42 faculty 5',
  },
];

const selectOptionsSubject = [
  {
    label: 'Select Subject',
    value: '--Select--',
  },
  {
    label: 'Subject 1',
    value: '1',
  },
  {
    label: 'Subject 2',
    value: '2',
  },
];

const selectOptionsStatus = [
  {
    label: 'Select Date',
    value: '',
  },
  {
    label: 'Approved',
    value: 'Approved',
  },
  {
    label: 'Under process',
    value: 'Under process',
  },
  {
    label: 'Submitted',
    value: 'Submitted',
  },
];

const selectOptionsDuration = [
  {
    label: 'Select Duration',
    value: '--Select--',
  },
  {
    label: 'Duration 1',
    value: '1',
  },
  {
    label: 'Duration 2',
    value: '2',
  },
];
const selectOptionsAllocatedFaculty = [
  {
    label: 'Select Batch',
    value: '',
  },
  {
    label: 'ken42 faculty 1',
    value: 'ken42 faculty 1',
  },
  {
    label: 'ken42 faculty 2',
    value: 'ken42 faculty 2',
  },
  {
    label: 'ken42 faculty 3',
    value: 'ken42 faculty 3',
  },
  {
    label: 'ken42 faculty 4',
    value: 'ken42 faculty 4',
  },
  {
    label: 'ken42 faculty 5',
    value: 'ken42 faculty 5',
  },
];

const UserCellBulkMessage = (row, name) => {
  return (
    <p>
      <img
        style={{ borderRadius: '50%' }}
        width="40"
        height="40"
        src={row}
        alt="user"
      />
      {name}
    </p>
  );
};

const ExpandableTableRow = ({ children, expandComponent, ...otherProps }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <>
      <TableRow {...otherProps}>
        {children}
        <TableCell>
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      {isExpanded && (
        <TableRow style={{ backgroundColor: 'aliceblue' }}>
          {expandComponent}
        </TableRow>
      )}
    </>
  );
};

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));
function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}
TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const GradingDetails2 = ({
  gradingId,
  rows,
  setRows,
  onChange,
  onToggleEdit,
  onRevert,
  onToggleEditMode,
  onDataSave,
  getGradingDetailsData,
  loading,
  setLoading,
}) => {
  const history = useHistory();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [facultyDrop, setFacultyDrop] = useState({});
  const [selectValueDuration, setSelectValueDuration] = useState(
    selectOptionsDuration[0].value
  );

  const createData = (
    id,
    studentName,
    finalMidtermMarks,
    finalEndTermMarks,
    finalTotalMarks,
    calculatedGrade,
    penalty,
    finalGrade,
    quiz1,
    quiz2,
    project1,
    project2,
    assignment1,
    assignment2
    // saved
  ) => ({
    id,
    studentName,
    finalMidtermMarks,
    finalEndTermMarks,
    finalTotalMarks,
    calculatedGrade,
    penalty,
    finalGrade,
    quiz1,
    quiz2,
    project1,
    project2,
    assignment1,
    assignment2,
    // saved,
  });

  const selectOptionsAllocated = [
    {
      label: 'Completed',
      value: 'Completed',
    },
    {
      label: 'Pending',
      value: 'Pending',
    },
  ];

  const selectOptionsAllocated1 = [
    {
      label: 'Submitted',
      value: 'Submitted',
    },
    {
      label: 'Not Submitted',
      value: 'Not Submitted',
    },
  ];

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  // Editing
  // const [dataOfTable, setDataOfTable] = useState(data);
  const [isView, setIsView] = useState(false);
  const [messageDialog, setMessageDialog] = useState(false);
  function handleMessageDialog() {
    setMessageDialog((prevState) => !prevState);
  }
  const handleClickOnView = () => {
    setIsView(true);
  };

  const DataWithLimit = rows.slice(0, 2);

  const [sliderDialog, setSliderDialog] = useState(false);

  /* table pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleClickSlider = () => {
    handleSliderDialog();
  };
  function handleSliderDialog() {
    console.log('data');
    setSliderDialog((prevState) => !prevState);
  }
  const onProfileView = () => {};

  // const getRevalExamDetailsDataListing = () => {
  //   getRevalData().then((res) => {
  //     const ReTestDetailsInfo =
  //       res === null
  //         ? []
  //         : res.map((item, index) => {
  //             console.log('itemitemforRestest', item);
  //             return {
  //               id: item.id ? item.id : '',
  //               course: item.courseName ? item.courseName : '',
  //               student: item.studentName ? item.studentName : '',
  //               term: item.termName ? item.termName : '',
  //               exam_type: item.examType ? item.examType : '',
  //               previous_marks: item.previousMarks ? item.previousMarks : '',
  //               document_submitted: item.documentStatus
  //                 ? item.documentStatus
  //                 : '',
  //               no_of_documents: item.numberofDocuments
  //                 ? item.numberofDocuments
  //                 : '',
  //               revaluation_due_date: item.revalDueDate
  //                 ? item.revalDueDate
  //                 : '',
  //               status: item.status ? item.status : '',
  //               reason: item.reason ? item.reason : '',
  //             };
  //           });

  //     // setRows(ReTestDetailsInfo);
  //     setFilterDialog(false);
  //   });
  // };
  // useEffect(() => {
  //   // getRevalExamDetailsDataListing();
  //   getGradingDetailsData();
  // }, []);
  useEffect(() => {
    GradingGet(gradingId).then((res) => {
      // console.log('itemres------------------------->', res);
      const data =
        res === null
          ? []
          : res?.data.SubjectScoreList?.map((item) => {
              console.log('itemitemitemitemitemitemitemitem', item);
              return {
                id: item.id,
                studentName: item.student,
                finalMidtermMarks: item.ComponentName,
                finalEndTermMarks: item.ComponentName,
                finalTotalMarks: item.TotalMarksObtained,
                calculatedGrade: item.CalculatedGrade,
                penalties: item.penality,
                finalGrade: item.finalGrade,
                courseOfferingId: item.CourseOfferingId,
                StudentId: item.StudentId,
              };
            });
      setRows(data);
    });
  }, []);

  return (
    <Box>
      <Box className={classes.breadCrumbWrapper}>
        {/* <BreadCrumb array={arrayBreadCrumb} history={history} /> */}
      </Box>
      {loading && <KenLoader />}
      <Box className={`cardlsitbox`}>
        <KenCard elevation={0}>
          <Table className={classes.table} aria-label="caption table">
            <TableHead>
              <TableRow>
                <TableCell className="tableHeaderTitle" align="left">
                  Student list
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Mid Term Exam
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  End Term Exam{' '}
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Total Marks Obt
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Calculated Grade
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Penalty
                </TableCell>{' '}
                <TableCell className="tableHeaderTitle" align="left">
                  Final Grade
                </TableCell>
                <TableCell className="tableHeaderTitle" align="left">
                  Edit
                </TableCell>
                <TableCell
                  className="tableHeaderTitle"
                  align="center"
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="tablebody1">
              {rows.length === 0 && (
                <TableCell colSpan={8}>No Record</TableCell>
              )}
              {rows &&
                (rowsPerPage > 0
                  ? rows.slice(
                      page * rowsPerPage,
                      page * rowsPerPage + rowsPerPage
                    )
                  : rows
                ).map((row) => {
                  const SetDateFormat = {
                    ...row,
                    examDate: moment(row.dateTimeofExam).format(
                      'YYYY-MM-DD HH:mm'
                    ),
                  };
                  {
                    console.log('rowrowrowrowrow111111111', row);
                  }
                  return (
                    <TableRow className="editableTableRowData" key={row.id}>
                      <>
                        {console.log('rowformeval', row)}
                        <TableCell className={classes.selectTableCell}>
                          <Button>
                            {' '}
                            <Link
                              className={classes.profile}
                              // onClick={() => onProfileView()}
                              style={{ fontSize: '10px' }}
                              to={{
                                pathname: `${routes.grading}/details/${row?.courseOfferingId}/studentdetails/${row?.StudentId}`,
                              }}
                            >
                              {row.studentName}
                            </Link>
                          </Button>
                        </TableCell>
                        <KenGridEditable
                          {...{
                            row: SetDateFormat,
                            onChange,
                            columns: [
                              // {
                              //   column_name: 'studentName',
                              //   is_inline_edit: false,
                              //   inline_edit_type: '',
                              //   label: 'StudentList',
                              // },

                              {
                                column_name: 'finalMidtermMarks',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'finalMidtermMarks',
                              },
                              {
                                column_name: 'finalEndTermMarks',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'finalEndTermMarks',
                              },
                              {
                                column_name: 'finalTotalMarks',
                                is_inline_edit: false,
                                inline_edit_type: '',
                                label: 'finalTotalMarks',
                              },
                              {
                                column_name: 'calculatedGrade',
                                is_inline_edit: true,
                                inline_edit_type: 'kenInput1',
                                label: 'calculatedGrade',
                              },
                              {
                                column_name: 'penalties',
                                is_inline_edit: true,
                                inline_edit_type: 'kenInput',
                                label: 'penalties',
                              },
                              {
                                column_name: 'finalGrade',
                                is_inline_edit: true,
                                inline_edit_type: 'kenInput1',
                                label: 'finalGrade ',
                              },
                            ],
                          }}
                        />
                        <TableCell className={classes.selectTableCell}>
                          {row.isEditMode ? (
                            <>
                              <IconButton
                                aria-label="done"
                                onClick={() => onToggleEditMode('done', row.id)}
                              >
                                <DoneIcon />
                              </IconButton>
                              <IconButton
                                aria-label="revert"
                                onClick={() => onRevert(row.id)}
                              >
                                <RevertIcon />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              aria-label="delete"
                              onClick={() => onToggleEditMode('edit', row.id)}
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </TableCell>

                        {/* {row.status === 'Under process' ? (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.error}
                              // to={`${routes.invigilationProctoring}/${id}`}
                            >
                              Under process
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    ) : (
                      <TableCell className={classes.selectTableCell}>
                        <Box>
                          <div style={{ display: 'flex' }}>
                            <Button
                              variant="primary"
                              component={Link}
                              className={classes.normal}
                              // to={`${routes.seatingPlan}/arrangement/${id}`}
                            >
                              Completed
                            </Button>
                          </div>
                        </Box>
                      </TableCell>
                    )} */}

                        {/* <TableCell className={classes.selectTableCell}>
                          {row.isEditMode ? (
                            <>
                              <IconButton
                                aria-label="done"
                                onClick={() => onToggleEditMode('done', row.id)}
                              >
                                <DoneIcon />
                              </IconButton>
                              <IconButton
                                aria-label="revert"
                                onClick={() => onRevert(row.id)}
                              >
                                <RevertIcon />
                              </IconButton>
                            </>
                          ) : (
                            <IconButton
                              aria-label="delete"
                              onClick={() => onToggleEditMode('edit', row.id)}
                            >
                              <EditIcon />
                            </IconButton>
                          )}
                        </TableCell> */}
                        {/* </TableRow> */}
                      </>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          <Box style={{ display: 'flex', justifyContent: 'center' }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={6}
              count={rows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </Box>
        </KenCard>
      </Box>

      {/*  ilhs*/}
    </Box>
  );
};

export default GradingDetails2;
